import React from 'react';

import { getEvents } from 'helper/api';
import { useParams } from 'react-router-dom';
import { FullPageLoader } from 'components/Loaders';
import SingleDetailedEvent from './SingleDetailedEvent';
import MoreEvents from './MoreEvents';

function EventDetails() {
  const { id } = useParams();
  const [event, setEvent] = React.useState(null);
  const [moreEvents, setMoreEvents] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  React.useEffect(() => {
    setLoading(true);
    getEvents()
      .then((result) => {
        setLoading(false);
        if (result.status) {
          const currentEvent = result.events.find((event) => event.id === id);
          const eventWithoutCurrent = result.events.filter(
            (event) => event.id !== id
          );
          setEvent(currentEvent);
          setMoreEvents(eventWithoutCurrent?.slice(0, 2));
        }
      })
      .catch((err) => {
        setLoading(false);
      });
  }, [id]);
  return (
    <div className="content">
      {loading ? <FullPageLoader /> : null}
      <section>
        <SingleDetailedEvent data={event} />
        <MoreEvents data={moreEvents} />
      </section>
    </div>
  );
}

export default EventDetails;
